import LandingPage from "./pages/LandingPage";
import {Route, Routes} from 'react-router-dom'
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import EmailVerification from "./pages/EmailVerification";
import ConfirmEmail from "./pages/ConfirmEmail";
import RedirectPage from "./pages/RedirectPage";
import Dashboard from "./pages/Dashboard";
import UserDashboard from "./pages/UserDashboard";
import NotFound from "./pages/NotFound";
import Settings from "./pages/Settings";
import RecentTransactions from "./components/RecentTransactions";
import GeneralSettings from "./components/GeneralSettings";
import BankSettings from "./components/BankSettings";
import Loading from "./components/Loading";
import PaymentForm from "./pages/PaymentForm";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./AuthProvider";
import Withdraw from "./pages/Withdraw";
import PaymentSuccessful from "./components/PaymentSuccessful";
import PaymentLoading from "./components/PaymentLoading";
import PaymentFailed from "./components/PaymentFailed";

function App() {
 

  return (
    <AuthProvider>
      <Routes>
       <Route
        exact
        path="/"
        element={<LandingPage/>}
       ></Route>
      <Route
        path="/signup"
        element={<SignUp/>}
       ></Route>
      <Route
        path="/login"
        element={<Login/>}
       ></Route>
       <Route 
       path="/dashboard/:username/:token/:id" 
       element={
        <ProtectedRoute >
             <Dashboard />
        </ProtectedRoute> 
       }>
         <Route index element={<UserDashboard/>} />
         <Route path="user-dashboard" element={<UserDashboard/>} />
         <Route path="recent-transactions" element={<RecentTransactions/>} />
         <Route path="withdraw" element={<Withdraw />} />
         <Route path="settings" element={<Settings/>}>
           <Route index element={<GeneralSettings />} />
           <Route path="general" element={<GeneralSettings />} />
           <Route path="bank-settings" element={<BankSettings />} />
           <Route path="*" element={<NotFound/>} />
         </Route>
         <Route path="*" element={<NotFound/>} />
       </Route>
      <Route
        path="/forgotpassword"
        element={<ForgotPassword/>}
       ></Route>
      <Route
        path="/resetpassword/:id/:token"
        element={<ResetPassword/>}
       ></Route>
      <Route
        path="/pay/:username"
        element={<PaymentForm/>}
       ></Route>
      <Route
        path="/verifyemail/:id"
        element={<EmailVerification/>}
       ></Route>
      <Route
        path="/confirmemail/:id/:token"
        element={<ConfirmEmail/>}
       ></Route>
      <Route
        path="/redirecting"
        element={<RedirectPage/>}
       ></Route>
      <Route
      exact
        path="/loading"
        element={<Loading/>}
       ></Route>
      <Route
      exact
        path="/payment"
        element={<PaymentLoading/>}
       ></Route>
      <Route
      exact
        path="/successful"
        element={<PaymentSuccessful/>}
       ></Route>
      <Route
      exact
        path="/failed"
        element={<PaymentFailed/>}
       ></Route>
       <Route path="*" element={<NotFound/>}>
       </Route>
       </Routes>
    </AuthProvider>
  );
}

export default App;
